<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent: 0em;">To my mother Esther, father Joel, and wife Selena, for all their support and encouragement. For my children Octavio, Joaquin, and Ayla. May they honor the sacrifices made by their ancestors.</p><br/>
<p style="text-indent: 0em;">A special thank you to Dr. Charles Bullock and Latricia Gianino for their incredible behind-the-scenes support and assistance.</p><br/>
<p style="text-indent: 0em;">To Francisco “Cisco” Munoz, Sr., Andrea Carmen, Alfred Urbina, and former Tribal Chairman Peter Yucupicio for their past and continued service in support of the Pascua Yaqui Tribe.</p><br/>
<p style="text-indent: 0em;">“Attach great importance to the Indigenous population of America…they will be so illumined as to enlighten the whole world.”</p>
<p style="text-indent: 0em;">Abdu’l-Baha </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?104625fb